import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { QrCode } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { schoolId } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", last_name: "", document: "", phone: "", whatsapp: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/register-parent", { ...form, school_id: schoolId });
      localStorage.setItem("activeSchool", schoolId);
      localStorage.setItem("activeSchoolName", r.data.school_name || "");
      setUser(r.data.user);
      toast.success(`Registro exitoso en ${r.data.school_name}`);
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 space-y-4" data-testid="register-parent-form">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-blue-800 text-white flex items-center justify-center">
            <QrCode className="w-5 h-5" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-900">Registro de Padre/Tutor</h1>
            <p className="text-xs text-slate-500">Completa tus datos para crear tu portal</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Nombre</Label><Input data-testid="register-name" value={form.name} onChange={set("name")} required /></div>
          <div className="space-y-1.5"><Label>Apellido</Label><Input data-testid="register-lastname" value={form.last_name} onChange={set("last_name")} required /></div>
        </div>
        <div className="space-y-1.5"><Label>Cédula / Documento</Label><Input data-testid="register-document" value={form.document} onChange={set("document")} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5"><Label>Teléfono</Label><Input data-testid="register-phone" value={form.phone} onChange={set("phone")} /></div>
          <div className="space-y-1.5"><Label>WhatsApp</Label><Input data-testid="register-whatsapp" value={form.whatsapp} onChange={set("whatsapp")} /></div>
        </div>
        <div className="space-y-1.5"><Label>Correo electrónico</Label><Input type="email" data-testid="register-email" value={form.email} onChange={set("email")} required /></div>
        <div className="space-y-1.5"><Label>Contraseña</Label><Input type="password" data-testid="register-password" value={form.password} onChange={set("password")} required /></div>
        <Button type="submit" data-testid="register-submit-button" disabled={loading} className="w-full bg-blue-800 hover:bg-blue-700">
          {loading ? "Registrando…" : "Crear mi cuenta"}
        </Button>
        <p className="text-xs text-slate-400 text-center">El colegio asociará tu cuenta a tu(s) hijo(s).</p>
      </form>
    </div>
  );
}
